import { isStableBusinessModeCode } from './businessModes';
import type { BusinessModeCode, StableBusinessModeCode } from './types';

export type QuoteModeDiscounts = Partial<
  Record<StableBusinessModeCode, number>
>;

/** 只接纳服务端现行模式及准确百分比；错误快照不能静默变成100%。 */
export function readQuoteModeDiscounts(value: unknown): QuoteModeDiscounts {
  if (value === undefined) return {};
  if (!value || typeof value !== 'object' || Array.isArray(value))
    throw new Error('业务模式折扣快照无效');
  const result: QuoteModeDiscounts = {};
  for (const [mode, raw] of Object.entries(value)) {
    if (
      !isStableBusinessModeCode(mode as StableBusinessModeCode) ||
      typeof raw !== 'string' ||
      !/^\d+(?:\.\d+)?$/.test(raw) ||
      !Number.isFinite(Number(raw)) ||
      Number(raw) < 0
    )
      throw new Error('业务模式折扣快照无效');
    result[mode as StableBusinessModeCode] = Number(raw);
  }
  return result;
}

/** 当前模式保留已编辑值；其它模式仅取自己的槽，未选择过时为100%。 */
export function quoteDiscountForMode(
  item: { discount: number; modeDiscounts?: QuoteModeDiscounts },
  target: StableBusinessModeCode,
  current: BusinessModeCode,
): number {
  return target === current
    ? item.discount
    : (item.modeDiscounts?.[target] ?? 100);
}
